import { PayCode } from "@/data/pay-codes";

import { TimeReportProjectSummaryItem } from "../types/TimeReportProjectSummaryItem";

export interface TimeReportProjectSummaryItemsGroup {
  payCode: PayCode;
  items: TimeReportProjectSummaryItem[];
}

export const groupTimeReportProjectSummaryItems = (items: TimeReportProjectSummaryItem[]) => {
  const result = [] as TimeReportProjectSummaryItemsGroup[];

  for (const item of items) {
    if (!result.length) {
      result.push({ payCode: item.payCode, items: [item] });
      continue;
    }

    if (result[result.length - 1].payCode.guid === item.payCode.guid) {
      result[result.length - 1].items.push(item);
    } else {
      result.push({ payCode: item.payCode, items: [item] });
    }
  }

  return result;
};
